import formatValue from '../@material/summaryComponent/utils/formatValue';
export { replaceJsonPathBuzzwords } from './componentUtils';

export const FIELDIDENTIFIER = 'field:';
export const SYSTEMIDENTIFIER = 'system:';
export const RESPONSE_IDENTIFIER = 'response:';
export const DATEFORMATOPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  timeZoneName: 'short',
};

export const URL_PARAMS_IDENTIFIER = '{/urlParams/}';

export function findAllValuesToReplace(text: string, identifier: string) {
  let words = text
    .replace(/<\/?[^>]+(>|$)/g, ' ') // strip out opening and closing html tags
    .replace(/^&nbsp;$/g, ' ')
    .replace(/[,. ?!;]/g, ' ')
    .replace(/^\n$/g, ' ')
    .split(/\n| /);

  return words.filter((word) => word.includes(identifier));
}

export function findAllNestedValuesToReplace(
  text: string,
  identifier: string
): string[] {
  const re = new RegExp(
    `${identifier}(?:[A-Za-z_$][\\w$]*|\\d+)(?:\\.(?:[A-Za-z_$][\\w$]*|\\d+))*`,
    'g'
  );
  return Array.from(new Set(text.match(re) ?? []));
}

export function replaceAllBuzzwordsWithValues(
  values: Record<string, any> | undefined = {},
  buzzwords: string[] | undefined = [],
  systemBuzzwords: string[],
  text: string
): string {
  buzzwords.forEach(
    (buzzword) =>
      (text = text.replace(
        buzzword,
        formatValue(values[buzzword.replace(FIELDIDENTIFIER, '')] ?? '')
      ))
  );
  text = replaceAllSystemValues(systemBuzzwords, text);
  return text.trim();
}

function replaceAllSystemValues(systemBuzzwords: string[], text: string) {
  systemBuzzwords.forEach((systemBuzzword) => {
    switch (systemBuzzword) {
      case SYSTEMIDENTIFIER + 'timestamp':
        text = text.replace(
          systemBuzzword,
          new Date(Date.now()).toLocaleString('de-DE', DATEFORMATOPTIONS)
        );
        break;

      default:
        break;
    }
  });
  return text;
}
